import * as Yup from 'yup';
export const initialReasonForLeavingValues = {
    description: '',
    enumId: '',
};
export const reasonForLeavingSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=reason-for-leaving.js.map